import { CHAT_ROUTE, ERROR_MESSAGE, MEETING_OK_RES, getComagicId } from "@/constants"
import { socket } from "@/modules/socket"
import type { Message, ServerMessage } from "@/types"
import { type Dispatch, type SetStateAction, useEffect } from "react"
import { v4 as uuidv4 } from "uuid"

interface Props {
  setMessages: Dispatch<SetStateAction<Message[]>>
  setSending?: (value: boolean) => void
  scrollToBottom: () => void
}

export function useChatSocket(props: Props) {
  const { setMessages, setSending, scrollToBottom } = props

  useEffect(() => {
    function socketHandler(message: ServerMessage) {
      setSending?.(false)

      if (message?.error) {
        setMessages((prev) => [...prev, { id: uuidv4(), sender: "bot", text: ERROR_MESSAGE, date: new Date().toISOString(), reaction: null }])
      } else if (message) {
        if (message.text === MEETING_OK_RES && Comagic) {
          Comagic.openWidget(getComagicId())
        }

        setMessages((prev) => [...prev, { id: message.id, sender: "bot", text: message.text, date: message.date, reaction: null }])
      }

      scrollToBottom()
    }

    socket.on(CHAT_ROUTE, socketHandler)

    return () => {
      socket.off(CHAT_ROUTE, socketHandler)
    }
  }, [setMessages, setSending, scrollToBottom])
}
